import { defineNuxtPlugin, markRaw } from '#imports';

export default defineNuxtPlugin((nuxtApp) => {
  // @ts-expect-error - do not throw error
  nuxtApp.$pinia.use(({ store }) => {
    // @ts-expect-error - do not throw error
    store.router = markRaw(nuxtApp.$router);
  });
});
